import EastIcon from '@mui/icons-material/East'
import { Box, Container, Grid, TextField } from '@mui/material'
import { TitleSection, CustomButton } from '@src/components'
import { useTranslation } from 'react-i18next'
import { ChangeEvent, FC } from 'react'
import InfoContact from './InfoContact'

interface ContactUsProps {
  errors: { name: string; email: string; message: string }
  formData: {
    name: string
    email: string
    message: string
  }
  handleSubmit: (e: ChangeEvent<HTMLFormElement, Element>) => void
  handleChange: (name: string, event:  ChangeEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => void
  isPending?: boolean
}

const ContactForm: FC<ContactUsProps> = ({
  errors,
  formData: { name, email, message },
  handleSubmit,
  handleChange,
}) => {
  const { t } = useTranslation()

  const hasInvalidFields = Object.values({ name, email, message }).some((field) => !field)

  return (
    <>
    
    <TitleSection title={t('contact.title')} />
   
    <Container
      component="main"
      sx={{
        flexGrow: 1 ,
        color: 'white',
        '& .MuiTextField-root': {
          marginBottom: '1rem',
          input: {
            color: '#fff',
            borderRadius: '4px',
          },
          textarea: {
            color: '#fff',
            borderRadius: '4px', 
          },
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.23)', 
          },
          '&:hover fieldset': {
            borderColor: 'white', 
          },
          '&.Mui-focused fieldset': {
            borderColor: '#4caf50', 
          },
        },
        '& .MuiButton-root': {
          marginTop: '1rem',
          backgroundColor: '#4caf50', 
          '&:hover': {
            backgroundColor: '#357a38', 
          },
        },
      }}
    >
     <Grid container>
      <Grid size={{ xs: 12, md: 9, lg: 9 }}>
      <Box sx={{ padding: { xs: '0 1px', sm: '0 20px',},boxSizing: 'border-box',}} >

        <InfoContact />

        <form onSubmit={handleSubmit}>
          <TextField
            label={t('contact.yourName')}
            variant="outlined"
            type="name"
            value={name}
            onChange={(event) => handleChange('name', event)}
            error={Boolean(errors.name)}
            helperText={errors.name}
            sx={{ width: { md: '60%' } }} 
            fullWidth 
          />

          <TextField
            label={t('contact.yourEmail')}
            variant="outlined"
            type="email"
            value={email}
            onChange={(event) => handleChange('email', event)}
            error={Boolean(errors.email)}
            helperText={errors.email}
            sx={{ width: { md: '60%' } }} 
            fullWidth 
          />

          <TextField
            label={t('contact.yourMessage')}
            variant="outlined"
            multiline
            rows={4}
            value={message}
            onChange={(event) => handleChange('message', event)}
            error={Boolean(errors.message)}
            helperText={errors.message}
            sx={{ width: { md: '90%' } }} 
            fullWidth 
          />
          <CustomButton
              title={t('contact.send')}
              Icon={EastIcon}
              type="submit"
              disabled={hasInvalidFields}
            />
        </form>
        </Box>
    </Grid>
     </Grid>
    </Container>
    </>
  )
}

export default ContactForm
